var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGemini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2.08636719 0.61746094 2.17273438 1.23492188 2.26171875 1.87109375 C3.64855364 10.23027285 6.12905242 17.06103949 12.9375 22.4375 C18.35387845 26.10927715 23.54406536 27.22528784 30 28 C30 28.66 30 29.32 30 30 C29.39414062 30.07476562 28.78828125 30.14953125 28.1640625 30.2265625 C19.84752475 31.53161919 12.21523173 34.60243545 7 41.5 C3.75831151 46.70496462 2.72509405 51.95754958 2 58 C1.34 58 0.68 58 0 58 C-0.08636719 57.38253906 -0.17273438 56.76507813 -0.26171875 56.12890625 C-1.47607925 48.80932047 -3.31110477 42.12652282 -9.15234375 37.17578125 C-15.22508982 33.0026629 -20.65002397 30.86470306 -28 30 C-28 29.34 -28 28.68 -28 28 C-27.38253906 27.91363281 -26.76507812 27.82726562 -26.12890625 27.73828125 C-18.80932047 26.52392075 -12.12652282 24.68889523 -7.17578125 18.84765625 C-3.0026629 12.77491018 -0.86470306 7.34997603 0 0 Z ",
    fill: "#3A91D9",
    transform: "translate(31,3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGemini);
export default __webpack_public_path__ + "static/media/gemini.72f1861128b2385cb70a8b3ec932afed.svg";
export { ForwardRef as ReactComponent };